import { Link } from 'react-router-dom';
import { useI18n } from '@/i18n/LanguageContext';
import Seo from '@/components/Seo';

/**
 * 404 page.
 *
 * SEO DEFECT THIS FIXES: this page previously rendered NO <Seo> block, so a
 * missing URL kept whatever <title>, description and canonical the previously
 * viewed page had installed (or, on a cold load, the static index.html values)
 * and still advertised `index,follow`. On SPA static hosting the response body
 * for an unknown path is index.html with HTTP 200, so that combination is a
 * textbook soft 404: search engines were being invited to index unlimited
 * non-existent URLs under the homepage's own title.
 *
 * Now the page declares its own title/description and `noindex,nofollow`, and
 * offers crawlable links back into the real public destinations.
 */
const NotFound = () => {
  const { t, path, lang } = useI18n();
  const es = lang === 'es';

  return (
    <div className="mx-auto flex max-w-lg flex-col items-center px-4 py-24 text-center">
      <Seo
        title={es ? 'Página no encontrada' : 'Page not found'}
        description={
          es
            ? 'Esa página no existe. Vuelva al inicio o explore los proyectos de construcción publicados.'
            : 'That page does not exist. Return home or browse the posted construction projects.'
        }
        noindex
      />
      <p className="text-6xl font-extrabold text-slate-900">404</p>
      <h1 className="mt-4 text-lg text-slate-600">
        {es ? 'No encontramos esa página.' : 'We could not find that page.'}
      </h1>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to={path('/')} className="rounded-xl bg-slate-900 px-6 py-3.5 text-base font-bold text-white hover:bg-slate-800">
          {es ? 'Ir al inicio' : 'Go home'}
        </Link>
        <Link to={path('/jobs')} className="rounded-xl border border-slate-300 px-6 py-3.5 text-base font-bold text-slate-800 hover:bg-slate-50">
          {t('jobs.title')}
        </Link>
      </div>
      <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-sm font-semibold text-slate-500">
        <Link to={path('/how-it-works')} className="hover:text-slate-900">{t('nav.howItWorks')}</Link>
        <Link to={path('/pricing')} className="hover:text-slate-900">{t('nav.pricing')}</Link>
        <Link to={path('/trades')} className="hover:text-slate-900">{t('seo.allTrades')}</Link>
        <Link to={path('/contact')} className="hover:text-slate-900">{t('footer.contactUs')}</Link>
      </div>
    </div>
  );
};

export default NotFound;
